import { render, staticRenderFns } from "./consulta_articulos.vue?vue&type=template&id=4cef4377&"
import script from "./consulta_articulos.vue?vue&type=script&lang=js&"
export * from "./consulta_articulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports